import { createContext, useContext } from 'react'

import { VoidPromiseHandler } from 'common/types'
import { Promo } from 'reducers/banner/promoContactListReducer'
import { ContactItem } from 'reducers/contactList/contactList.types'

export interface ContactListValue {
  contactList: (ContactItem | Promo)[]
  onLoadMoreContactList: VoidPromiseHandler
  hasNextPage: boolean
  isEdit: boolean
  isLoading: boolean
  contactListCount: number
  isIgnoreContactList?: boolean
}

export const ContactListContext = createContext<ContactListValue>({
  contactList: [],
  onLoadMoreContactList: () => Promise.resolve(),
  hasNextPage: false,
  isEdit: false,
  isLoading: false,
  contactListCount: 0,
})

export const useContactListContext = (): ContactListValue => {
  return useContext(ContactListContext)
}
